import { TICKS_PER_BAR, TICKS_PER_BEAT } from '../shared/tempo';
import { FULL_CLASSES } from './full';
import { KIFFEUR } from './kiffeur';
import type { ClassDefinition } from './types';

export const CLASSES: readonly ClassDefinition[] = [
  {
    id: 'mage',
    name: 'La Luxiole',
    role: 'Balaie la foule de loin avec ses poi lumineux. Fragile.',
    color: '#ff2bd6',
    maxHp: 90,
    speed: 7.5,
    radius: 14,
    pickupRadius: 80,
    attack: {
      kind: 'straight',
      damage: 10,
      cooldownTicks: TICKS_PER_BEAT / 2,
      projectileSpeed: 16,
      projectileRadius: 6,
      rangeTicks: 30,
      pierce: 0,
      count: 1,
      spreadRadians: 0.2,
    },
    skill: {
      id: 'nova',
      name: 'Nova',
      description: 'Tu libères une onde de lumière qui repousse les bad vibes autour de toi.',
      cooldownTicks: 2 * TICKS_PER_BAR,
      effect: { kind: 'nova', damage: 60, radius: 190, knockback: 60 },
    },
  },
  {
    id: 'tank',
    name: 'Le Nounours',
    role: 'Tient la ligne et attire les bad vibes. Lent.',
    color: '#ff9a3d',
    maxHp: 210,
    speed: 6.8,
    radius: 18,
    pickupRadius: 120,
    attack: {
      kind: 'straight',
      damage: 17,
      cooldownTicks: 7,
      projectileSpeed: 10,
      projectileRadius: 10,
      rangeTicks: 14,
      pierce: 0,
      count: 1,
      spreadRadians: 0,
      knockback: 30,
    },
    skill: {
      id: 'charge',
      name: 'Charge',
      description:
        'Tu fonces devant toi, intouchable, et les bad vibes alentour ne voient plus que toi.',
      cooldownTicks: TICKS_PER_BAR,
      effect: { kind: 'dash', distance: 160, invulnerableTicks: 10, tauntRadius: 160 },
    },
  },
  {
    id: 'healer',
    name: "L'Hygie",
    role: 'Soigne, répare la scène et relève ses amis.',
    color: '#7cf2b0',
    maxHp: 130,
    speed: 7,
    radius: 14,
    pickupRadius: 90,
    shadeRadius: 60,
    reviveMul: 1.25,
    attack: {
      kind: 'straight',
      damage: 17,
      cooldownTicks: 10,
      projectileSpeed: 12,
      projectileRadius: 6,
      rangeTicks: 28,
      pierce: 0,
      count: 1,
      spreadRadians: 0,
    },
    skill: {
      id: 'soin',
      name: 'Soin',
      description: 'Tu soignes ceux qui sont près de toi et tu répares un peu la scène.',
      cooldownTicks: 5 * TICKS_PER_BAR,
      effect: { kind: 'healPulse', amount: 8, radius: 120, coreRepair: 10 },
    },
  },
  KIFFEUR,
  ...FULL_CLASSES,
];
